import axios from '@/global-axios'
import {
    getSpanishLocaleDateFormat
} from '@/helpers.js'

/*
// Most of the consol.log(err) statements should be avoided here and catched
// in the function that uses any of these actions.
*/
export default {
    setHomeActiveCareer ({ commit }, careerName) {
        commit('SET_HOME_ACTIVE_CAREER', careerName)
    },
    async getAllCourses ({ commit }) {
        const res = await axios.get('/courses')
        commit('SET_COURSES_LIST', res.data)
    },
    async readRecentSitesRelatedToUser ({ commit, state }) {
        // Returns an array of maximum 5 semesters that comply with the condition of being
        // relatively recent
        const res2 = await axios.get('/semesters/today')
        var recentSites = []
        const currentSemesters = res2.data
        commit('SET_CURRENT_POSSIBLE_SEMESTERS', currentSemesters)

        if (state.userData.relatedSites.length && currentSemesters.length) {
            currentSemesters.forEach((semester) => {
                state.userData.relatedSites.forEach((site) => {
                    if (site.semesterId === semester.id) {
                        recentSites.push(site)
                    }
                })
            })
        }

        commit('SET_USER_RELATED_RECENT_SITES', recentSites)
    },

    // CreateSite Page Actions
    async readSemesterOptions ({ state }, queryParams) {
        // queryParams is an object that can have the following query parameters:
        // offset, limit, academic_period
        let queryArray = []
        for (var paramKey in queryParams) {
            queryArray.push(`${paramKey}=${queryParams[paramKey]}`)
        }
        let queryString = ''
        if (queryArray.length) {
            queryString = `?${queryArray.join('&')}`
        }
        const res = await axios.get(`/semesters${queryString}`)

        return res.data.data
    },
    async createCourseSite ({ state }, payload) {
        await axios.post(`/courses/${payload.courseCode}/sites`, {
            semester_id: payload.semesterId
        })
    },

    // User Credentials Actions
    async logIn ({ commit }, authData) {
        try {
            const res = await axios.post('/sessions', {
                identity_card: authData.identity_card,
                password: authData.password
            })
            const token = res.data.token
            localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, token)
            axios.defaults.headers.common[process.env.VUE_APP_TOKEN_NAME] = token
            commit('AUTHENTICATE_USER', token)
        } catch (err) {
            localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME)
            delete axios.defaults.headers.common[process.env.VUE_APP_TOKEN_NAME]
            commit('CLEAR_AUTHENTICATED_USER')
            throw err
        }
    },
    async getUserData ({ commit, dispatch }) {
        // Read from the backend the User basic info and then retrieve their related sites and
        // calculate their recent sites in the same action.
        const res = await axios.get('/users/me')
        console.log({ user_data: res.data })
        commit('SET_USER_DATA', res.data)
        await dispatch('readSitesRelatedToUser')
    },
    async logOut ({ commit }) {
        await axios.delete('/sessions')
        localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME)
        delete axios.defaults.headers.common[process.env.VUE_APP_TOKEN_NAME]
        commit('CLEAR_AUTHENTICATED_USER')
        commit('RESET_USER_DATA')
    },
    async requestPasswordRecoveryEmail ({ commit }, idNumber) {
        await axios.post(`/users/${idNumber}/recovery_token`)
    },
    async resetPassword ({ commit }, payload) {
        await axios.put(`/users/password_change/${payload.resetToken}`, { password: payload.password })
    },
    async changeCurrentUserPassword ({ commit }, newPassword) {
        await axios.put('/users/me', { password: newPassword })
    },
    async changeCurrentUserEmail ({ commit }, newEmail) {
        await axios.put('/users/me', { email: newEmail })
        commit('SET_USER_EMAIL', newEmail)
    },
    async changeCurrentUserNotifications ({ commit }, newEmailSettings) {
        await axios.put('/users/me', { email_settings: newEmailSettings })
        commit('SET_USER_NOTIFICATIONS', newEmailSettings)
    },

    // AdminPage actions
    setAdminActiveCareer ({ commit }, careerName) {
        commit('SET_ADMIN_ACTIVE_CAREER', careerName)
        commit('SET_ADMIN_SELECTED_COURSE', null)
    },
    setAdminSelectedCourse ({ commit }, selectedCourse) {
        commit('SET_ADMIN_SELECTED_COURSE', selectedCourse)
    },
    async readCourseByCode ({ commit }, courseCode) {
        const res = await axios.get(`/courses/${courseCode}`)
        console.log(res)
        return res
    },
    async createCourse ({ commit }, payload) {
        await axios.post('/courses', {
            code: payload.code,
            name: payload.name,
            careers: payload.careers,
            credit_units: payload.creditUnits,
            requirements: payload.requirements,
            type: payload.type,
            classification: payload.classification
        })
    },
    async editCourse ({ commit }, payload) {
        await axios.put(`/courses/${payload.oldCode}`, {
            code: payload.code,
            name: payload.name,
            careers: payload.careers,
            credit_units: payload.creditUnits,
            requirements: payload.requirements,
            type: payload.type,
            classification: payload.classification
        })
    },
    async deleteCourse ({ commit }, courseCode) {
        const res = await axios.delete(`/courses/${courseCode}`)
        return res
    },
    async readUserByIdCardNumber ({ commit }, IdCardNumber) {
        const res = await axios.get(`/users/${IdCardNumber}`)
        return res
    },
    async readAllAdminProfessors ({ commit, dispatch }) {
        const professors = await dispatch('readAllProfessors', {})
        commit('SET_PROFESSORS_LIST', professors)
    },
    async readAllProfessors ({ commit }, queryParams) {
        // queryParams is an object that can have the following query parameters:
        // offset, limit, orderCol, orderDir, where, name, lastname, email and identity_card
        let queryArray = []
        for (var paramKey in queryParams) {
            queryArray.push(`${paramKey}=${queryParams[paramKey]}`)
        }
        let queryString = ''
        if (queryArray.length) {
            queryString = `?${queryArray.join('&')}`
        }
        const res = await axios.get(`/professors${queryString}`)
        return res.data.data
    },
    setAdminSelectedProfessor ({ commit }, selectedProfessor) {
        commit('SET_ADMIN_SELECTED_PROFESSOR', selectedProfessor)
    },
    async createProfessor ({ commit }, payload) {
        await axios.post('/professors', {
            identity_card: payload.idCardNumber,
            name: payload.name,
            lastname: payload.lastName,
            email: payload.email,
            password: payload.password
        })
    },
    async editProfessor ({ commit }, payload) {
        await axios.put(`/professors/${payload.oldIdCardNumber}`, {
            identity_card: payload.idCardNumber,
            name: payload.name,
            lastname: payload.lastName,
            email: payload.email
        })
    },
    async editProfessorPassword ({ commit }, payload) {
        await axios.put(`/professors/${payload.idCardNumber}/edit-password`, {
            password: payload.password
        })
    },
    async deleteProfessor ({ commit }, idCardNumber) {
        const res = await axios.delete(`/professors/${idCardNumber}`)
        return res
    },
    async readAllAdminStudents ({ commit, dispatch }) {
        const students = await dispatch('readAllStudents', {})
        commit('SET_STUDENTS_LIST', students)
    },
    async readAllStudents ({ commit }, queryParams) {
        // queryParams is an object that can have the following query parameters:
        // offset, limit, orderCol, orderDir, where, name, lastname, email and identity_card
        let queryArray = []
        for (var paramKey in queryParams) {
            queryArray.push(`${paramKey}=${queryParams[paramKey]}`)
        }
        let queryString = ''
        if (queryArray.length) {
            queryString = `?${queryArray.join('&')}`
        }
        const res = await axios.get(`/students${queryString}`)
        return res.data.data
    },
    async createStudent ({ commit }, payload) {
        await axios.post('/students', {
            identity_card: payload.idCardNumber,
            name: payload.name,
            lastname: payload.lastName,
            email: payload.email,
            password: payload.password
        })
    },
    async editStudent ({ commit }, payload) {
        await axios.put(`/students/${payload.oldIdCardNumber}`, {
            identity_card: payload.idCardNumber,
            name: payload.name,
            lastname: payload.lastName,
            email: payload.email
        })
    },
    async editStudentPassword ({ commit }, payload) {
        await axios.put(`/students/${payload.idCardNumber}/edit-password`, {
            password: payload.password
        })
    },
    setAdminSelectedStudent ({ commit }, selectedStudent) {
        commit('SET_ADMIN_SELECTED_STUDENT', selectedStudent)
    },
    async deleteStudent ({ commit }, idCardNumber) {
        const res = await axios.delete(`/students/${idCardNumber}`)
        return res
    },

    // ////////////////////////////////////////////////////////////////
    //                        SitePage actions                       //
    // ////////////////////////////////////////////////////////////////

    async readServerTime ({ commit }) {
        const res = await axios.get(`/serverTime`)
        commit('SET_SERVER_TIME', res.data.time)
    },
    async changeSiteCoordinator ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/coordinator`, {
            coordinator_id: payload.coordinatorId
        })
    },
    async addProfessorToSite ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/professors`, {
            professor_id: payload.professorId,
            email: payload.email
        })
    },
    async updateProfessorInSite ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/professors/${payload.professorId}`, {
            email: payload.email
        })
    },
    async deleteProfessorFromSite ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/professors/${payload.professorId}`)
    },
    async addStudentTeacherToSite ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/studentteachers`, {
            student_id: payload.studentId,
            email: payload.email,
            type: payload.position
        })
    },
    async updateStudentTeacherInSite ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/studentteachers/${payload.studentId}`, {
            email: payload.email,
            type: payload.position
        })
    },
    async deleteStudentTeacherFromSite ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/studentteachers/${payload.studentId}`)
    },
    async readCourseSiteByAcademicPeriod ({ commit }, payload) {
        const courseCode = payload.courseCode
        const academicPeriod = payload.academicPeriod
        const res = await axios.get(`/courses/${courseCode}/sites/${academicPeriod}`)
        console.log({ siteResponse: res })
        console.log({ siteassignments: res.data.assignments })
        commit('SET_ACTIVE_SITE', res.data)
    },
    async deleteCourseSiteById ({ commit }, courseSiteId) {
        await axios.delete(`/sites/${courseSiteId}`)
    },
    async readPreviousSemesterCourseSites ({ commit, dispatch }, courseSiteId) {
        const res = await dispatch('readCourseByCode', courseSiteId)
        const previousSemestersSites = res.data.sites
        commit('SET_PERVIOUS_SEMESTERS_SITE', previousSemestersSites)
    },
    async readCourseSiteStudents ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/students`)
        console.log({ students: res.data })
        commit('SET_ACTIVE_SITE_STUDENTS', res.data)
    },
    async addStudentToSite ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/students`, {
            student_id: payload.studentId,
            section_id: payload.sectionId
        })
    },
    async uploadStudentListFileToSite ({ commit }, payload) {
        const formData = new FormData()
        formData.append('file', payload.file, payload.file.name)
        await axios.post(`/sites/${payload.courseSiteId}/students`, formData)
    },
    async deleteStudentFromSite ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/students/${payload.studentId}`)
    },
    async readCourseSiteLogs ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/logs`)
        commit('SET_ACTIVE_SITE_LOGS', res.data)
    },
    async readCourseSiteAssignments ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/assignments`)
        console.log({ retrieveAssignments: res.data })
        commit('SET_ACTIVE_SITE_ASSIGNMENTS', res.data)
    },
    async readCourseSiteForumPosts ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/forums`)
        console.log({ retrieveForums: res.data })
        commit('SET_ACTIVE_SITE_FORUMS', res.data)
    },
    async updateCourseSiteNewsConfig ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/config`, {
            notices_type: payload.displayTwitterFeed,
            notices_twitter: payload.twitterId
        })
    },
    resetActiveSite ({ commit }) {
        commit('RESET_ACTIVE_SITE_DATA')
    },
    async readSitesRelatedToUser ({ state, getters, commit, dispatch }) {
        // Retrieve the User related sites and calculate their most recent sites.
        if (getters.isUserAuthenticated && state.userData.id !== null) {
            const res = await axios.get(`/users/me/sites`)
            const sites = res.data
            var formattedSites = []
            var aux
            // Formatting related sites where the user has the professor role
            if (sites.professor.professorSite && sites.professor.professorSite.length) {
                aux = sites.professor.professorSite
                aux.map(profSite => {
                    formattedSites.push({
                        id: profSite.site.id,
                        course: profSite.site.course,
                        semesterId: profSite.site.semester_id,
                        role: state.userRoles.professor
                    })
                })
            }
            // Formatting related sites where the user has the coordinator role
            if (sites.professor.coordinatorSite && sites.professor.coordinatorSite.length) {
                aux = sites.professor.coordinatorSite
                aux.map(coordSite => {
                    formattedSites.push({
                        id: coordSite.id,
                        course: coordSite.course,
                        semesterId: coordSite.semester_id,
                        role: state.userRoles.coordinator
                    })
                })
            }
            // Formatting related sites where the user has the studentTeacher role
            if (sites.student.studentTeacher && sites.student.studentTeacher.length) {
                aux = sites.student.studentTeacher
                aux.map(stTeacherSite => {
                    formattedSites.push({
                        id: stTeacherSite.site.id,
                        course: stTeacherSite.site.course,
                        semesterId: stTeacherSite.site.semester_id,
                        role: state.userRoles.studentTeacher
                    })
                })
            }
            // Formatting related sites where the user has the student role
            if (sites.student.studentSite && sites.student.studentSite.length) {
                aux = sites.student.studentSite
                aux.map(studentSite => {
                    formattedSites.push({
                        id: studentSite.site.id,
                        course: studentSite.site.course,
                        semesterId: studentSite.site.semester_id,
                        role: state.userRoles.student
                    })
                })
            }

            commit('SET_USER_RELATED_SITES', formattedSites)

            await dispatch('readRecentSitesRelatedToUser')
        }
    },
    async sendEmailToSiteUsers ({ commit }, payload) {
        await axios.post(`/sendEmailToSite/${payload.courseSiteId}`, {
            professors: payload.professors,
            students: payload.studentTeachers,
            sections: payload.sectionIds,
            subject: payload.subject,
            body: payload.body
        })
    },

    // SitePages CRUD Actions

    async createSiteObjective ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/objectives`, {
            description: payload.description
        })
    },
    async updateSiteObjective ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/objectives/${payload.objectiveId}`, {
            description: payload.description
        })
    },
    async deleteSiteObjective ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/objectives/${payload.objectiveId}`)
    },
    async createSiteBibliography ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/bibliographies`, {
            title: payload.title,
            authors: payload.authors,
            description: payload.description
        })
    },
    async updateSiteBibliography ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/bibliographies/${payload.bibliographyId}`, {
            title: payload.title,
            authors: payload.authors,
            description: payload.description
        })
    },
    async deleteSiteBibliography ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/bibliographies/${payload.bibliographyId}`)
    },
    async createSiteThematicContent ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/contents`, {
            title: payload.title,
            description: payload.description
        })
    },
    async updateSiteThematicContent ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/contents/${payload.contentId}`, {
            title: payload.title,
            description: payload.description
        })
    },
    async deleteSiteThematicContent ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/contents/${payload.contentId}`)
    },
    // ////////////////// Timetables and Sections CRUD ////////////////// //
    async readSiteSectionsByQuery ({ commit }, query) {
        const res = await axios.get(`/sections?name=${query}`)
        return res.data
    },
    async createSiteSection ({ commit }, sectionName) {
        const res = await axios.post(`/sections`, {
            name: sectionName
        })
        return res.data
    },
    async createSiteTimetable ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/schedule`, {
            section_id: payload.sectionId,
            user_id: payload.instructorId,
            day: payload.weekday,
            initial_hour: payload.startHour,
            final_hour: payload.endHour,
            type: payload.activityType,
            classroom: payload.classroom,
            schedule_only: payload.scheduleOnly
        })
    },
    async updateSiteTimetable ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/schedule/${payload.timetableId}`, {
            section_id: payload.sectionId,
            user_id: payload.instructorId,
            day: payload.weekday,
            initial_hour: payload.startHour,
            final_hour: payload.endHour,
            type: payload.activityType,
            classroom: payload.classroom,
            schedule_only: payload.scheduleOnly
        })
    },
    async deleteSiteTimetable ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/schedule/${payload.timetableId}`)
    },
    // ////////////////// Evaluations CRUD ////////////////// //
    async createSiteEvaluation ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/evaluations`, {
            name: payload.name,
            type: payload.activityType,
            value: payload.value,
            initial_date: payload.startDate,
            final_date: payload.endDate
        })
    },
    async updateSiteEvaluation ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/evaluations/${payload.evaluationId}`, {
            name: payload.name,
            type: payload.activityType,
            value: payload.value,
            initial_date: payload.startDate,
            final_date: payload.endDate
        })
    },
    async deleteSiteEvaluation ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/evaluations/${payload.evaluationId}`)
    },
    // ////////////////// Surveys and Survey Builder CRUD ////////////////// //
    async readSiteTeacherSurveys ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/surveys`)
        console.log({ teacherSurveys: res.data })
        commit('SET_ACTIVE_SITE_TEACHER_SURVEYS', res.data)
    },
    async readSingleSiteTeacherSurvey ({ commit }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}`)
        console.log({ wholeSurvey: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async readSiteStudentSurveys ({ commit, state }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/surveys/student/${state.userData.studentId}`)
        console.log({ studentSurveys: res.data })
        commit('SET_ACTIVE_SITE_STUDENT_SURVEYS', res.data)
    },
    async readSingleBasicStudentSurvey ({ commit, state }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/student/${state.userData.studentId}`)
        console.log({ basicStudentSurvey: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async readSingleWholeStudentSurvey ({ commit, state }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/student/${state.userData.studentId}/whole`)
        console.log({ basicStudentSurvey: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async readStudentSurveyAnswers ({ commit, state }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/student/${state.userData.studentId}/answers`)
        console.log({ studentSurveyAnswers: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async readStudentSurveyAnswersDetails ({ commit }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/student_surveys/${payload.studentSurveyId}/survey/${payload.surveyId}/answers`)
        console.log({ studentSurveyAnswersDetails: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async readAllSurveysDownloadData ({ commit }, courseSiteId) {
        const res = await axios({
            url: `/sites/${courseSiteId}/surveys/download`,
            method: 'GET',
            responseType: 'blob',
            headers: {
                'Accept': 'application/octet-stream'
            }
        })
        // console.log({ res })
        return res.data
    },
    async createSiteSurvey ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/surveys`, {
            name: payload.name,
            description: payload.description,
            is_evaluated: payload.isEvaluated,
            show_answers: payload.showAnswers,
            duration_minutes: payload.durationMinutes
        })
    },
    async cloneSiteSurvey ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/clone`, {
            new_name: payload.newName
        })
    },
    async updateSiteSurvey ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}`, {
            name: payload.name,
            description: payload.description,
            is_evaluated: payload.isEvaluated,
            show_answers: payload.showAnswers,
            duration_minutes: payload.durationMinutes
        })
    },
    async openSiteSurvey ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/open`)
    },
    async closeSiteSurvey ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}/close`)
    },
    async addStudentsToSurvey ({ commit }, payload) {
        const res = await axios.post(`/sites/${payload.courseSiteId}/student_surveys`, {
            survey_id: payload.surveyId,
            student_site_ids: payload.studentSiteIds
        })
        return res.data
    },
    async removeStudentsFromSurvey ({ commit }, payload) {
        const res = await axios.delete(`/sites/${payload.courseSiteId}/student_surveys`, { data: {
            survey_id: payload.surveyId,
            student_site_ids: payload.studentSiteIds
        } })
        return res.data
    },
    async startStudentSurvey ({ commit, state }, payload) {
        const res = await axios.put(`/sites/${payload.courseSiteId}/student_surveys/${payload.studentSurveyId}/start/${state.userData.studentId}`)
        console.log({ wholeStudentSurvey: res.data })
        commit('SET_SELECTED_SURVEY_OBJECT', res.data)
    },
    async completeStudentSurvey ({ commit, state }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/student_surveys/${payload.studentSurveyId}/complete/${state.userData.studentId}`)
    },
    async restartStudentSurvey ({ commit, state }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/student_surveys/${payload.studentSurveyId}/restart`)
    },
    async deleteSiteSurvey ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/surveys/${payload.surveyId}`)
    },
    async createSiteSurveyQuestion ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/questions`, {
            survey_id: payload.surveyId,
            body: payload.body,
            answer_type: payload.answerType,
            value: payload.value
        })
    },
    async updateSiteSurveyQuestion ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/questions/${payload.questionId}`, {
            survey_id: payload.surveyId,
            body: payload.body,
            answer_type: payload.answerType,
            value: payload.value
        })
    },
    async switchSurveyQuestionOrders ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/questions`, {
            survey_id: payload.surveyId,
            question_id1: payload.questionId1,
            question_id2: payload.questionId2
        })
    },
    async deleteSiteSurveyQuestion ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/questions/${payload.questionId}`, { data: {
            survey_id: payload.surveyId
        } })
    },
    async createSiteSurveyQuestionChoice ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/choices`, {
            survey_id: payload.surveyId,
            survey_question_id: payload.surveyQuestionId,
            body: payload.body,
            is_correct: payload.isCorrect
        })
    },
    async updateSiteSurveyQuestionChoice ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/choices/${payload.choiceId}`, {
            survey_id: payload.surveyId,
            survey_question_id: payload.surveyQuestionId,
            body: payload.body,
            is_correct: payload.isCorrect
        })
    },
    async deleteSiteSurveyQuestionChoice ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/choices/${payload.choiceId}`, { data: {
            survey_id: payload.surveyId,
            survey_question_id: payload.surveyQuestionId
        } })
    },
    async updateStudentSurveyAnswer ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/student_surveys/${payload.studentSurveyId}/answers`, {
            survey_id: payload.surveyId,
            survey_question_id: payload.surveyQuestionId,
            selected_choices_json_ids: payload.selectedChoicesJsonIds
        })
    },
    // ////////////////// Assignments and Assignment files CRUD ////////////////// //
    async readStudentAssignmentFile ({ commit }, payload) {
        const res = await axios.get(`/students/me/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}/files`)
        console.log({ StudentFile: res.data })
        var currentFile = {
            id: res.data.id,
            originalFilename: res.data.original_name,
            latestUpdateDate: getSpanishLocaleDateFormat(res.data.updated_at),
            size: res.data.size
        }
        return currentFile
    },
    async createStudentAssignmentFile ({ commit }, payload) {
        const formData = new FormData()
        formData.append('assignmentFile', payload.file, payload.file.name)
        await axios.post(`/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}/files`, formData)
    },
    async updateStudentAssignmentFile ({ commit }, payload) {
        const formData = new FormData()
        formData.append('assignmentFile', payload.file, payload.file.name)
        await axios.put(
            `/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}/files/${payload.fileId}`,
            formData
        )
    },
    async readAllFilesFromAssignment ({ commit }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}/files`)
        console.log({ assignmentFiles: res.data })
        return res.data
    },
    async createSiteAssignment ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/assignments`, {
            name: payload.name,
            delivery_date: payload.deadlineDate,
            max_size: payload.maxSize
        })
    },
    async updateSiteAssignment ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}`, {
            name: payload.name,
            delivery_date: payload.deadlineDate,
            max_size: payload.maxSize
        })
    },
    async deleteSiteAssignment ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/assignments/${payload.assignmentId}`)
    },
    // ////////////////// Site News CRUD ////////////////// //
    async createSiteNews ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/notices`, {
            title: payload.title,
            notice: payload.body
        })
    },
    async updateSiteNews ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/notices/${payload.newsId}`, {
            title: payload.title,
            notice: payload.body
        })
    },
    async deleteSiteNews ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/notices/${payload.newsId}`)
    },
    // ////////////////// Forum Posts and Comments CRUD ////////////////// //
    async createSiteForumPost ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/forums`, {
            title: payload.title,
            description: payload.body
        })
    },
    async updateSiteForumPost ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/forums/${payload.forumPostId}`, {
            title: payload.title,
            description: payload.body
        })
    },
    async deleteSiteForumPost ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/forums/${payload.forumPostId}`)
    },
    async readForumPostComments ({ commit }, payload) {
        const res = await axios.get(`/sites/${payload.courseSiteId}/forums/${payload.forumPostId}/comments`)
        console.log({ retrieveForumPostComments: res.data })
        commit('SET_SELECTED_FORUM_POST_COMMENTS', res.data)
    },
    async createForumPostComment ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/forums/${payload.forumPostId}/comments`, {
            comment: payload.body
        })
    },
    async deleteForumPostComment ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/forums/${payload.forumPostId}/comments/${payload.commentId}`)
    },
    // /////////////////////// Grades //////////////////////////////////// //
    async readSingleStudentGrades ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/students/me/grades`)
        console.log({ singleGrades: res.data })
        commit('SET_SINGLE_STUDENT_GRADES', res.data)
    },
    async readCourseSiteGrades ({ commit }, courseSiteId) {
        const res = await axios.get(`/sites/${courseSiteId}/grades`)
        console.log({ siteGrades: res.data })
        commit('SET_ACTIVE_SITE_GRADES', res.data)
    },
    async updateSingleStudentGrade ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/evaluations/${payload.evaluationId}/grades/${payload.gradeId}`, {
            grade: payload.gradeValue
        })
    },
    async readAllGradesDownloadData ({ commit }, courseSiteId) {
        const res = await axios({
            url: `/sites/${courseSiteId}/grades/download`,
            method: 'GET',
            responseType: 'blob',
            headers: {
                'Accept': 'application/octet-stream'
            }
        })
        console.log({ res })
        return res.data
    },

    // /////////////// Scheduling Events //////////////// //
    async createSchedulingEvent ({ commit }, payload) {
        const res = await axios.post(`/sites/${payload.courseSiteId}/planifications`, {
            name: payload.name,
            description: payload.description,
            initial_date: payload.startDate,
            final_date: payload.endDate
        })
        return res.data
    },
    async updateSchedulingEvent ({ commit }, payload) {
        const res = await axios.put(`/sites/${payload.courseSiteId}/planifications/${payload.eventId}`, {
            name: payload.name,
            description: payload.description,
            initial_date: payload.startDate,
            final_date: payload.endDate
        })
        return res.data
    },
    async deleteSchedulingEvent ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/planifications/${payload.eventId}`)
    },

    // ///////////////// Downloads Section CRUD ////////////// //
    async createSiteDownloadFile ({ commit }, payload) {
        const formData = new FormData()
        formData.append('downloadFile', payload.file, payload.file.name)
        formData.append('name', payload.name)
        formData.append('type', payload.downloadType)
        await axios.post(`/sites/${payload.courseSiteId}/files`, formData)
    },
    async deleteSiteDownloadFile ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/files/${payload.fileId}`)
    },
    async createSiteHyperlink ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/links`, {
            name: payload.name,
            url: payload.url
        })
    },
    async deleteSiteHyperlink ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/links/${payload.linkId}`)
    },
    async createSiteVideo ({ commit }, payload) {
        await axios.post(`/sites/${payload.courseSiteId}/videos`, {
            name: payload.name,
            url: payload.url
        })
    },
    async increaseSiteVideoViews ({ commit }, payload) {
        await axios.put(`/sites/${payload.courseSiteId}/videos/${payload.videoId}`)
    },
    async deleteSiteVideo ({ commit }, payload) {
        await axios.delete(`/sites/${payload.courseSiteId}/videos/${payload.videoId}`)
    }

}
